import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => {
    setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  };

  const next = () => {
    setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));
  };

  const testimonial = testimonials[current];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            Testimonials
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 mb-2">
            Trusted by 10,000+ Shoppers
          </h2>

          {/* Rating badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-950 text-background-50 text-sm font-medium mt-3 mb-8">
            <i className="ri-star-fill text-accent-500 text-sm"></i>
            <span>4.9 Rating</span>
          </div>

          {/* Quote */}
          <blockquote className="mb-8">
            <p className="font-heading text-lg md:text-xl text-foreground-800 leading-relaxed italic">
              &ldquo;{testimonial.quote}&rdquo;
            </p>
          </blockquote>

          {/* Author */}
          <div className="flex items-center justify-center gap-3 mb-8">
            <img
              src={testimonial.avatar}
              alt={testimonial.name}
              className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover"
            />
            <div className="text-left">
              <p className="text-sm md:text-base font-semibold text-foreground-950">{testimonial.name}</p>
              <p className="text-xs md:text-sm text-foreground-500">{testimonial.role}</p>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-200 text-foreground-500 hover:text-foreground-950 hover:border-foreground-500 transition-colors cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <div className="flex items-center gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrent(index)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    index === current
                      ? 'bg-primary-500 w-5'
                      : 'bg-foreground-200 hover:bg-foreground-300'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}